// Which copy of the system is this page?
//
// Live has no entry here. The test copies (staging, dev) each have their OWN
// backend, and a test page must never send requests anywhere else: if its
// /default/paths.json points at another server (for example the live API) the
// page stops before it makes a single request.
const OWN_BACKEND = {
  staging: 'hg-gb1-staging.vdepot.co.uk',
  dev: 'hg-gb1-dev.vdepot.co.uk',
};
// The paths.json entries that carry requests or links to a backend. imgHost is
// left out on purpose: it only fetches product pictures (read-only).
const BACKEND_KEYS = ['apiHost', 'utilityHost', 'legacyHost'];
// The live address. A test copy's settings file must never end up behind it.
const LIVE_HOSTS = ['my.vdepot.co.uk'];

function hostOf(url) {
  try { return new URL(url).hostname.toLowerCase(); } catch (e) { return ''; }
}

// 'staging' or 'dev' when this page is served from staging.my... / dev.my...,
// otherwise null (live, or a developer's own machine).
export function hostInstance(hostname) {
  var m = /^(staging|dev)\./i.exec(hostname === undefined ? window.location.hostname : hostname);
  return m ? m[1].toLowerCase() : null;
}

// paths: the parsed /default/paths.json.
// Returns {env, problem}. env is 'staging', 'dev' or null (live / local).
// problem is a plain-English reason this page must not start, '' when all is well.
export function checkInstance(paths, hostname) {
  var fromHost = hostInstance(hostname);
  var host = (hostname === undefined ? window.location.hostname : hostname).toLowerCase();
  var declared = paths && paths.environment ? String(paths.environment).toLowerCase() : null;
  if (declared && !OWN_BACKEND[declared]) {
    return {env: fromHost, problem: 'The settings file (default/paths.json) names the environment "' + paths.environment + '", which is not a known test site.'};
  }
  if (declared && LIVE_HOSTS.indexOf(host) !== -1) {
    return {env: null, problem: 'This is the live address, but the settings file (default/paths.json) says it is the "' + declared + '" test site.'};
  }
  if (declared && fromHost && declared !== fromHost) {
    return {env: fromHost, problem: 'This page is served from the ' + fromHost + ' address, but the settings file (default/paths.json) says "' + declared + '".'};
  }
  var env = fromHost || declared;
  if (!env) {
    return {env: null, problem: ''};
  }
  for (var i = 0; i < BACKEND_KEYS.length; i++) {
    var key = BACKEND_KEYS[i];
    var value = paths && paths[key];
    if (hostOf(value) !== OWN_BACKEND[env]) {
      return {env: env, problem: 'The settings file (default/paths.json) ' + (value ? 'sends ' + key + ' to "' + value + '"' : 'has no ' + key) +
        ', but the ' + env + ' site may only use ' + OWN_BACKEND[env] + '.'};
    }
  }
  return {env: env, problem: ''};
}

// The "are you sure?" text shown before a pack is completed on a test copy: there it is
// only saved in the copy's own database and no label is made. env is 'staging', 'dev' or
// null. null (live, or a developer's own machine) gives null, so nothing changes there.
export function packNotice(env) {
  if (env !== 'staging' && env !== 'dev') { return null; }
  return (env === 'dev' ? 'DEV' : 'STAGING') + ' TEST COPY\n\n' +
    'This pack will NOT be recorded in the live system, and no label will print.\n' +
    'It is only saved in the ' + env + ' test database.\n\n' +
    'Pack it anyway?';
}



// WEBPACK FOOTER //
// ./src/functions/instance.js